import React, { useState } from 'react';
import { XIcon, CalendarIcon, ClipboardListIcon } from 'lucide-react';
import { AnyContact } from '../types';
interface ScheduleFollowUpModalProps {
  contact: AnyContact | null;
  isVisible: boolean;
  onClose: () => void;
  onSave: (contactId: string, date: string, nextAction: string) => void;
}
export function ScheduleFollowUpModal({
  contact,
  isVisible,
  onClose,
  onSave
}: ScheduleFollowUpModalProps) {
  const [date, setDate] = useState('');
  const [nextAction, setNextAction] = useState('');
  if (!isVisible || !contact) return null;
  const handleSave = () => {
    if (date && nextAction.trim()) {
      onSave(contact.id, date, nextAction);
      setDate('');
      setNextAction('');
    }
  };
  return <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50 flex items-center justify-center p-4" data-id="element-291">
      <div className="bg-olympian-surface border border-olympian-border rounded-xl shadow-2xl w-full max-w-md overflow-hidden animate-crossfade" data-id="element-292">
        <div className="px-6 py-4 border-b border-olympian-border flex justify-between items-center bg-olympian-navy/50" data-id="element-293">
          <h2 className="text-sm font-bold text-theme uppercase tracking-wider" data-id="element-294">
            Schedule Follow-up
          </h2>
          <button onClick={onClose} className="text-olympian-textMuted hover:text-theme transition-colors" data-id="element-295">
            <XIcon className="w-5 h-5" data-id="element-296" />
          </button>
        </div>

        <div className="p-6" data-id="element-297">
          <div className="mb-6 bg-olympian-navy p-3 rounded-lg border border-olympian-border" data-id="element-298">
            <p className="text-xs text-olympian-textMuted mb-1 uppercase tracking-wider font-bold" data-id="element-299">
              Contact
            </p>
            <p className="font-medium text-theme" data-id="element-300">
              {contact.name}{' '}
              <span className="text-olympian-textMuted font-mono ml-2 text-sm" data-id="element-301">
                {contact.phone}
              </span>
            </p>
          </div>

          <div className="mb-4" data-id="element-302">
            <label className="block text-xs font-bold text-olympian-textMuted uppercase tracking-wider mb-2" data-id="element-303">
              Follow-up Date
            </label>
            <div className="relative" data-id="element-304">
              <CalendarIcon className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-olympian-textMuted" data-id="element-305" />
              <input type="date" value={date} onChange={e => setDate(e.target.value)} className="w-full pl-10 pr-3 py-2.5 bg-olympian-navy border border-olympian-border rounded-lg text-sm text-theme focus:ring-1 focus:ring-olympian-gold focus:border-olympian-gold outline-none [color-scheme:dark]" data-id="element-306" />
            </div>
          </div>

          <div className="mb-8" data-id="element-307">
            <label className="block text-xs font-bold text-olympian-textMuted uppercase tracking-wider mb-2" data-id="element-308">
              Next Action <span className="text-red-400" data-id="element-309">*</span>
            </label>
            <div className="relative" data-id="element-310">
              <ClipboardListIcon className="absolute left-3 top-3 w-4 h-4 text-olympian-textMuted" data-id="element-311" />
              <textarea rows={2} value={nextAction} onChange={e => setNextAction(e.target.value)} placeholder="e.g. Call to discuss rate options, Send pre-approval letter..." className="w-full pl-10 pr-3 py-2.5 bg-olympian-navy border border-olympian-border rounded-lg text-sm text-theme focus:ring-1 focus:ring-olympian-gold focus:border-olympian-gold outline-none resize-none placeholder-olympian-textMuted/50" data-id="element-312"></textarea>
            </div>
          </div>

          <div className="flex justify-end gap-3" data-id="element-313">
            <button onClick={onClose} className="px-5 py-2.5 text-sm font-medium text-theme bg-olympian-navy hover:bg-olympian-navyLight border border-olympian-border rounded-lg transition-colors" data-id="element-314">
              Cancel
            </button>
            <button onClick={handleSave} disabled={!date || !nextAction.trim()} className="px-5 py-2.5 text-sm font-bold text-olympian-navy bg-olympian-gold hover:bg-olympian-goldHover rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-315">
              Save & Snooze
            </button>
          </div>
        </div>
      </div>
    </div>;
}